import { isNumber } from './isNumber';
import { isObject } from './isObject';
import { isString } from './isString';
export function validateIdentity(identity, log) {
    if (!isObject(identity)) {
        log.error('Identity must be an object with key and trafficType.');
        return;
    }
    var key = identity.key, trafficType = identity.trafficType;
    if (isNumber(key))
        key = key + '';
    if (!isString(key)) {
        log.error('Identity Key must be a string or number.');
        return;
    }
    if (!isString(trafficType)) {
        log.error('Identity Traffic Type must be a string.');
        return;
    }
    return {
        key: key.trim(),
        trafficType: trafficType.trim().toLowerCase()
    };
}
export function areEqual(identity1, identity2) {
    return identity1.key === identity2.key && identity1.trafficType === identity2.trafficType;
}
